<template>
    <input
        :class="{
                'my-3': !noMargin
           }"
        :placeholder="innerLabel"
        :value="innerValue"
        @input="validate($event.target.value)"
        class="bg-white focus:outline-none focus:border-primary border-2 border-info rounded-full py-3 px-4 block w-full appearance-none leading-normal"
    >
</template>

<script>
    export default {
        name: "TextInput",
        props: {
            value: {
                type: [String, Number]
            },
            label: {
                type: String
            },
            rules: {
                type: Array
            },
            noMargin: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            innerValue: null,
            innerLabel: null,
            validated: false,
            validationExpressions: {
                email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                mobile: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/

            }
        }),
        methods: {
            cloneInner() {
                this.innerValue = JSON.parse(JSON.stringify(this.value || ''));
                this.innerLabel = JSON.parse(JSON.stringify(this.label || ''));
                if (this.rules.includes('required')) {
                    this.innerLabel += '*';
                }
            },
            emitValue(value) {
                if (this.innerValue !== this.value) {
                    this.$emit('input', value);
                }
                this.$emit('valid', this.validated);
            },
            validate(value) {
                if (this.rules.includes('required')) {
                    this.setErrorState(value.length < 1);
                } else {
                    this.setErrorState(false);
                }
                if (this.rules.includes('email')) {
                    this.setErrorState(!this.validationExpressions.email.test(value));
                }
                if (this.rules.includes('mobile')) {
                    this.setErrorState(!this.validationExpressions.mobile.test(value));
                }
                this.emitValue(value);
            },
            setErrorState(state) {
                if (state) {
                    this.$el.classList.remove('focus:border-primary');
                    this.$el.classList.add('focus:border-error');
                    this.validated = false;
                } else {
                    this.$el.classList.remove('focus:border-error');
                    this.$el.classList.add('focus:border-primary');
                    this.validated = true;
                }
            }
        },
        mounted() {
            this.cloneInner();
        }
    }
</script>

<style scoped>
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type=number] {
        -moz-appearance: textfield;
    }
</style>